<template lang="pug">
    div(v-if="noResults")
        slot
            p No results found

</template>

<script>
import SearchComponent from './component'

export default {
    extends: SearchComponent,
    computed: {
        noResults() {
            return this.$searchContext.state.results.length === 0
        },
    },
}
</script>
